// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module__container___AtVKb","title":"style-module__title___3z1FW","description":"style-module__description___27mZT"};